export default __webpack_public_path__ + "static/media/MtDoomPaddock.130dd5dd.jpg";